<input
  class="text-input"
  type="text"
  inputmode="numeric"
  autocomplete="off"
  [class.form-error-border]="error"
  [attr.id]="controlId"
  [attr.aria-invalid]="error ? true : null"
  [maskito]="maskOptions"
  [value]="value"
  [disabled]="disabled"
  [placeholder]="placeholder"
  (focus)="inputFocused.emit()"
  (input)="handleInput($event)"
  (blur)="handleBlur()" />
